import { ContentTypeView } from '../api/client'

export function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ')
}

/**
 * The name in our social media service enums might not map exactly to
 * a name in the font awesome library.
 * @param socialMediaServiceName
 * @returns An icon name, like 'fa-tiktok'
 */
export function faIconName(socialMediaServiceName: string | undefined, showColours: boolean) {
    let faIconName = ''

    if (socialMediaServiceName === 'reddit') {
        faIconName = `fa-reddit ${showColours ? 'text-[#FF5700]' : ''}`
    }

    switch (socialMediaServiceName) {
        case 'all platforms':
            break
        case 'twitter':
            faIconName = `fa-x-twitter ${showColours ? 'text-[#000000]' : ''}`
            break
        case 'tiktokad':
            faIconName = `fa-tiktok ${showColours ? 'tiktok' : ''}`
            break
        case 'tiktokuser':
            faIconName = `fa-tiktok ${showColours ? 'tiktok' : ''}`
            break
        case 'youtube':
            faIconName = `fa-youtube ${showColours ? 'text-[#ff0000]' : ''}`
            break
        case 'instagram':
            faIconName = `fa-instagram ${showColours ? 'text-[#000000]' : ''}`
            break
        case 'facebook':
            faIconName = `fa-facebook ${showColours ? 'text-[#0866ff]' : ''}`
            break
        default:
            faIconName = `fa-${socialMediaServiceName?.toLocaleLowerCase()}`
    }
    return faIconName
}

/**
 * Maps ContentType to FontAwesome icon names
 * @param contentType The content type to get an icon for
 * @param showColours Whether to include color classes
 * @param socialMediaServiceName Optional service name to use as fallback for Unknown content types
 * @returns An icon name with optional color classes
 */
export function generateContentTypeFontAwesomeName(
    contentType: ContentTypeView,
    showColours: boolean = false,
    socialMediaServiceName: string | undefined
) {
    let icon = ''
    if (socialMediaServiceName === 'reddit') {
        return faIconName(socialMediaServiceName, showColours)
    }

    switch (contentType) {
        case ContentTypeView.InstagramPostComment:
        case ContentTypeView.InstagramAdComment:
            icon = `fa-instagram ${showColours ? 'text-[#000000]' : ''}`
            break
        case ContentTypeView.FacebookMessengerMessage:
            icon = `fa-facebook-messenger ${showColours ? 'text-[#0084ff]' : ''}`
            break
        case ContentTypeView.FacebookPagePostComment:
        case ContentTypeView.FacebookAdComment:
            icon = `fa-facebook ${showColours ? 'text-[#0866ff]' : ''}`
            break
        case ContentTypeView.TikTokAdComment:
        case ContentTypeView.TikTokUserVideoComment:
            icon = `fa-tiktok ${showColours ? 'tiktok' : ''}`
            break
        case ContentTypeView.YouTubeVideoComment:
            icon = `fa-youtube ${showColours ? 'text-[#ff0000]' : ''}`
            break
        case ContentTypeView.TwitterPostReply:
            icon = `fa-x-twitter ${showColours ? 'text-[#000000]' : ''}`
            break
        case ContentTypeView.Unknown:
        default:
            icon = faIconName(socialMediaServiceName, showColours)
    }
    return icon
}

// use "fa-solid fa-paper-plane" for Instagram Messenger
